const POSITIONS = {
    top: "top",
    "top-left": "top-left",
    "top-right": "top-right",
    bottom: "bottom",
    "bottom-left": "bottom-left",
    "bottom-right": "bottom-right"
};
export default POSITIONS;
